/**
 * AS REGRAS DO "TROCAR DE CONTA" (1.4, 23/10/2026; `docs/PLANO-TROCAR-DE-CONTA.md`), sem aparelho e sem servidor — para o
 * teste. Quem guarda: a equipe (professor, gestão, administração) e as contas de teste (`demo…`, `zz…`, a mesma regra de
 * `backend/src/utils/contasSinteticas.ts`). Aluno nunca entra na lista — o servidor também recusa (`CONTA_GUARDADA_SO_DA_EQUIPE`).
 */
export const MAXIMO_DE_CONTAS = 5;

export type ContaGuardada = { userId: number; username: string; nome: string; papel: string; credencialId: number | null; guardadaEm: string };

export function podeGuardar(u: { role?: string; username?: string } | null | undefined): boolean {
  if (!u) return false;
  if (u.role && u.role !== 'STUDENT') return true;
  return /^(demo|zz)/i.test(u.username ?? '');
}

/** Põe (ou atualiza) a conta. Passou do limite: não põe, e diz por quê. */
export function acrescentar(lista: ContaGuardada[], conta: ContaGuardada): { lista: ContaGuardada[]; erro?: 'LIMITE' | 'ALUNO' } {
  if (!podeGuardar({ role: conta.papel, username: conta.username })) return { lista, erro: 'ALUNO' };
  const sem = lista.filter((c) => c.userId !== conta.userId);
  if (sem.length >= MAXIMO_DE_CONTAS) return { lista, erro: 'LIMITE' };
  return { lista: [...sem, conta] };
}

export const remover = (lista: ContaGuardada[], userId: number) => lista.filter((c) => c.userId !== userId);

/** A ordem da troca: a prova guardada no aparelho vem ANTES de tudo (nem a biometria é pedida). */
export function podeTrocar(p: { provaGuardada: boolean; mesmaConta: boolean }): 'PROVA' | 'MESMA' | null {
  if (p.provaGuardada) return 'PROVA';
  if (p.mesmaConta) return 'MESMA';
  return null;
}

export const PAPEL: Record<string, string> = { TEACHER: 'Professor', SCHOOL_STAFF: 'Gestão', ADMIN: 'Administração', STUDENT: 'Aluno (teste)' };
export const FRASE_DA_PROVA = 'Há uma prova guardada neste aparelho. Termine ou entregue a prova antes de trocar de conta.';
export const FRASE_DO_LIMITE = `Este aparelho já guarda ${MAXIMO_DE_CONTAS} contas. Saia de uma para adicionar outra.`;
